<base-modal-component class="base-modal" [validation]="isValid()" (onConfirm)="save()">
    <fields-list-component [fields]="fields" name="operators" [value]="location"></fields-list-component>
</base-modal-component>
